import './ClashRegister.css';

import SubTabSection from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabSection";
import GetRegister from "../../../functions/GetRegister";

import DirectClashIcon from '../../../../_media/clashbot/direct_clash.svg';
import PotentialClashIcon from '../../../../_media/clashbot/potential_clash.svg';
import PotentialPotentialClashIcon from '../../../../_media/clashbot/potential_potential_clash.svg'
import GhostClashIcon from '../../../../_media/clashbot/ghost_clash.svg';
import NoClashIcon from '../../../../_media/clashbot/no_clash.svg';
import SubTabNoData from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabNoData";
import { faExclamation } from "@fortawesome/free-solid-svg-icons";
import { UpdateHistory } from "../../../functions/UpdateHistory";


function ClashRegister(props)
{
  const auditionees = props.additional.auditionees;
  const clashBotData = props.additional.clashBotData;
  const setClashBotData = props.additional.setClashBotData;
  const register = props.additional.register;
  const setRegister = props.additional.setRegister;
  const setSelected = props.additional.setSelected;

  if(auditionees.length === 0) {
    return (
      <SubTabNoData 
        icon={faExclamation} 
        title='No Auditionees' 
        description="No auditionees to display"
      />
    )
  }

  let registerDisplay = register.map((entry) => {

    const entryName = auditionees[entry.auditionee_id].names[0];

    const badges = {
      direct: (entry.current_choices.length > 1),
      potential: entry.potential_clash,
      potential_2: entry.potential_clash && entry.ghost_clash,
      ghost: !entry.potential_clash && entry.ghost_clash,
      none: (entry.current_choices.length === 1)
    }

    let optionsDisplay = entry.current_choices.map((choice, i) => {
      const project = clashBotData[choice.project_index];

      return (
        <div key={entryName + i}>
          <div className='clashbot-clash-item-option'>
            <p>
              <b>{project.roles[choice.role_index].name}</b><br/>
              <i>
                {project.name}<br/>
                <small>Week {project.week} {project.project_type}</small>
              </i>
            </p>
            <input type='checkbox' name={entryName} id={i} />
          </div>
          {i !== entry.current_choices.length - 1? (<hr style={{width: '100%'}}/>) : null}
        </div>
      )
    })

    const auditionee = auditionees[entry.auditionee_id]
    const firstName = auditionee.names[0].split(' ')[0];
    return (
      <div className='clash-sub-tab-section'>
        <div className='clashbot-clash-item'>
          <div className='clash-badge-container'>
            {badges.direct?       <ClashBadge src={DirectClashIcon} label={`${firstName} is first choice for more than one role`} colour='#d63031' /> : null}
            {badges.none?         <ClashBadge src={NoClashIcon} label={`${firstName} is first choice for only one role`} colour='#6ab04c' /> : null}
            {badges.potential?    <ClashBadge src={PotentialClashIcon} label={`${firstName} is also second choice for a clashing role`} colour='#f0932b' /> : null}
            {badges.ghost?  <ClashBadge src={GhostClashIcon} label={`${firstName} is also second choice for a non-clashing role`} colour='#22a6b3' /> : null}
          </div>
          <div>
            <h2 style={{marginBottom: -8}}>{auditionee.names[0]}</h2>
            <div style={{opacity: 0.7}}>{auditionee.phones.map(phone => {return <p key={phone}>{phone}</p>})}</div>
            <u style={{fontSize: '12px', opacity: '0.6', cursor: 'pointer'}} onClick={() => setSelected(entry.auditionee_id)}>View Details</u>
          </div>
          <div>{optionsDisplay}</div>
          <div style={{...{display: 'flex'},...{alignItems: 'center'},...{justifyContent: 'end'}}}>
            <button style={{...{height: '90px'},...{backgroundColor: '#00000000'},...{border: '1px solid #ff7675'},...{color: '#ff7675'}}} onClick={() => {
              const inputs = document.getElementsByName(entryName);
              Cast(entry, inputs, clashBotData, setClashBotData, auditionees, register, setRegister, props.additional.setHistory);
            }}>Cast</button>
          </div>
        </div>
      </div >
    )
  })

  return (
    <div className='clashes-tab'>
      {registerDisplay}
    </div>
  )
}

export default ClashRegister;



function ClashBadge({src, label, colour}) {
  return (
    <div className='clash-badge'>
      <img className='clash-icon' src={src} />
      <div className='clash-details' style={{backgroundColor: colour}}>
        {label}
      </div>
    </div>
  )
}



function Cast(auditionee, inputs, clashBotData, setClashBotData, auditionees, register, setRegister, setHistory) {

  const oldClashBotData = structuredClone(clashBotData);
  const oldRegister = structuredClone(register);
  const castRoleNames = [];
  const rejectedRoleNames = [];
  const neighbourRoleNames = [];

  // Set the chosen roles to cast, and remove as an option for the others
  inputs.forEach((input) => {
    const choice = auditionee.current_choices[input.id];
    const project = clashBotData[choice.project_index];

    // If the actor has chosen this role, set it as cast
    if(input.checked) {
      project.roles[choice.role_index].cast = true;
      console.log("1. CASTING AS " + project.roles[choice.role_index].name);
      castRoleNames.push(project.roles[choice.role_index].name);
    }
    else {
      project.roles[choice.role_index].choices[0] = null;
      console.log("2. REMOVING AS CHOICE FOR " + project.roles[choice.role_index].name);
      rejectedRoleNames.push(project.roles[choice.role_index].name);
    }
  }) 

  // Remove the auditionee from the system where required
  inputs.forEach((input) => {
    const choice = auditionee.current_choices[input.id];
    const project = clashBotData[choice.project_index];

    // If the auditionee has chosen this project, remove it as an option from it and neighbouring shows
    if(input.checked)
    {
      clashBotData.forEach((p) => {
        if(p.week === project.week || p.week === project.week - 1 || p.week === project.week + 1) {
          p.roles.forEach((role) => {
            if(role.cast !== true) {
              role.choices.forEach((choice, i) => {
                if(choice === auditionee.auditionee_id) {
                  console.log("3. REMOVING AS CHOICE FOR " + role.name);
                  neighbourRoleNames.push(role.name);
                  role.choices[i] = null;
                }
              })
            }
          })
        }
      })
    }

    // If the auditionee has not chosen this project, remove them as an option for other roles within it
    else
    {
      clashBotData[choice.project_index].roles.forEach((role) => {
        if(role.cast !== true)
        {
          role.choices.forEach((choice, i) => {
            if(choice === auditionee.auditionee_id)
            {
              role.choices[i] = null;
              console.log("4. REMOVING AS CHOICE FOR " + role.name);
              neighbourRoleNames.push(role.name);
            }
          })
        }
      })
    }
  })

  // Uncheck all checkboxes
  auditionees.forEach((auditionee) => {
    var inputs = document.getElementsByName(auditionee.names[0]);
    inputs.forEach((input) => {
      input.checked = false;
    })
  })

  const name = auditionees[auditionee.auditionee_id].names[0];
  const titleStatement = `${name} was cast as${castRoleNames.map((c,i) => ` ${c}`)}`
  const smallStatements = [
    rejectedRoleNames.length ? `Rejected:${rejectedRoleNames.map((r,i) => ` ${r}`)}.` : null,
    neighbourRoleNames.length ? `Removed from:${neighbourRoleNames.map((n,i) => ` ${n}`)}.` : null
  ].filter(Boolean);
  const now = new Date();
  const time = now.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });
  UpdateHistory(oldRegister, oldClashBotData, time, titleStatement, smallStatements, setHistory)
  GetRegister(clashBotData, setClashBotData, setRegister);

}